module.exports = __webpack_public_path__ + "static/media/2_pl.93c42329.png";